import { CodigoEmpleado } from "../../types/CodigoEmpleado";
import IAction from "../../types/IAction";
import { readMessageBack } from "../../utils/readMessageBack";
import actionTypes from "../actionTypes";

export interface GetCodigosEmpleado {
  codigosEmpleado: CodigoEmpleado[];
  gettingCodigosEmpleado: boolean;
  gettingCodigosEmpleadoError: string;
}

export interface PostCodigoEmpleado {
  postingCodigoEmpleado: boolean;
  postingCodigoEmpleadoError: string;
}

export interface PostEnviarComunicado {
  postingEnviarComunicado: boolean;
  postingEnviarComunicadoError: string;
}

interface State
  extends GetCodigosEmpleado,
    PostCodigoEmpleado,
    PostEnviarComunicado {}

const initialState: State = {
  codigosEmpleado: null,
  gettingCodigosEmpleado: false,
  gettingCodigosEmpleadoError: null,

  postingCodigoEmpleado: false,
  postingCodigoEmpleadoError: null,

  postingEnviarComunicado: false,
  postingEnviarComunicadoError: null
};

export default function codigosEmpleadoReducer(
  state: State = initialState,
  action: IAction
): State {
  const snapshot = snapshotAction(state, action);

  // Llamada a resolver de snapshot
  state != snapshot &&
    !action.type.endsWith("_PENDING") &&
    action.meta &&
    action.meta.resolver &&
    action.meta.resolver({
      fulfilled: action.type.endsWith("_FULFILLED"),
      ...snapshot
    });

  return state != snapshot
    ? {
        ...state,
        ...snapshot
      }
    : state;
}

function snapshotAction(state: State = initialState, action: IAction) {
  switch (action.type) {
    // GET_CODIGOS_EMPLEADO_BY_USER
    case `${actionTypes.GET_CODIGOS_EMPLEADO_BY_USER}_PENDING`: {
      return {
        gettingCodigosEmpleado: true,
        gettingCodigosEmpleadoError: null
      };
    }
    case `${actionTypes.GET_CODIGOS_EMPLEADO_BY_USER}_REJECTED`: {
      return {
        codigosEmpleado: null,
        gettingCodigosEmpleado: false,
        gettingCodigosEmpleadoError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_CODIGOS_EMPLEADO_BY_USER}_FULFILLED`: {
      return {
        codigosEmpleado: action.payload.data,
        gettingCodigosEmpleado: false,
        gettingCodigosEmpleadoError: null
      };
    }

    // GET_CODIGOS_EMPLEADO_BY_CODIGO
    case `${actionTypes.GET_CODIGOS_EMPLEADO_BY_CODIGO}_PENDING`: {
      return {
        gettingCodigosEmpleado: true,
        gettingCodigosEmpleadoError: null
      };
    }
    case `${actionTypes.GET_CODIGOS_EMPLEADO_BY_CODIGO}_REJECTED`: {
      return {
        codigosEmpleado: null,
        gettingCodigosEmpleado: false,
        gettingCodigosEmpleadoError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_CODIGOS_EMPLEADO_BY_CODIGO}_FULFILLED`: {
      return {
        codigosEmpleado: action.payload.data,
        gettingCodigosEmpleado: false,
        gettingCodigosEmpleadoError: null
      };
    }

    // POST_CODIGO_EMPLEADO
    case `${actionTypes.POST_CODIGO_EMPLEADO}_PENDING`: {
      return {
        postingCodigoEmpleado: true,
        postingCodigoEmpleadoError: null
      };
    }
    case `${actionTypes.POST_CODIGO_EMPLEADO}_REJECTED`: {
      return {
        postingCodigoEmpleado: false,
        postingCodigoEmpleadoError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_CODIGO_EMPLEADO}_FULFILLED`: {
      return {
        postingCodigoEmpleado: false,
        postingCodigoEmpleadoError: null
      };
    }

    // POST_ENVIAR_COMUNICADO_CODIGOS_EMPLEADO
    case `${actionTypes.POST_ENVIAR_COMUNICADO_CODIGOS_EMPLEADO}_PENDING`: {
      return {
        postingEnviarComunicado: true,
        postingEnviarComunicadoError: null
      };
    }
    case `${actionTypes.POST_ENVIAR_COMUNICADO_CODIGOS_EMPLEADO}_REJECTED`: {
      return {
        postingEnviarComunicado: false,
        postingEnviarComunicadoError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_ENVIAR_COMUNICADO_CODIGOS_EMPLEADO}_FULFILLED`: {
      return {
        postingEnviarComunicado: false,
        postingEnviarComunicadoError: null
      };
    }

    // CLEAR_CODIGOS_EMPLEADO
    case actionTypes.CLEAR_CODIGOS_EMPLEADO: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}

export { initialState };
